const api = {

    state: {
        err_status: false,
        pending_status: true,
        data: []
    },

    getters: {
        getData(state) {
            return state.data
        },
        getErrStatus(state) {
            return state.err_status
        },
        getPendingStatus(state) {
            return state.pending_status
        }
    },
    actions: {
        initApi({ commit, state }, payload) {
            const { url, method = 'GET', data = null } = payload;
            let fetchOptions = {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
                fetchOptions.body = JSON.stringify(data);
            }
            fetch(url, fetchOptions)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(json => commit("INITPOSTSAPI", json))
                .catch(err => {
                    state.err_status = true;
                    console.error("API Error:", err);
                })
                .finally(
                    function () { state.pending_status = false; }
                );
        }
    },
    mutations: {
        INITPOSTSAPI(state, payload) {
            state.posts = payload
        }
    }
}
export default api